import { render, staticRenderFns } from "./NavbarVertical.vue?vue&type=template&id=9cd79436&scoped=true&"
import script from "./NavbarVertical.vue?vue&type=script&lang=js&"
export * from "./NavbarVertical.vue?vue&type=script&lang=js&"
import style0 from "./NavbarVertical.vue?vue&type=style&index=0&id=9cd79436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd79436",
  null
  
)

export default component.exports